import { ReactElement } from 'react'

import { Drawer as AntDrawer } from 'antd'
import { DrawerProps as AntDrawerProps } from 'antd/es/drawer'

import Icon from '../Icon/Icon'

export type DrawerProps = Omit<AntDrawerProps, 'placement' | 'closeIcon'>

export const Drawer = ({ ...props }: DrawerProps): ReactElement => {
    return (
        <AntDrawer
            placement="right"
            closeIcon={<Icon name="PLUS" rotate={45} size={20} />}
            {...props}
        />
    )
}

Drawer.displayName = 'Drawer'
